// Cold Compute / Neon — LOCKED visual tokens for the 2026 EAKC YouTube series.
//
// Sources of truth (do not drift without updating both):
//   docs/style-mockups/2026-06-04-cold-compute-neon-styleframes.html
//   docs/superpowers/specs/2026-06-04-eakc-neon-series-design.md
//
// This kit is recreated from scratch and is intentionally SEPARATE from the older
// src/shared3d/ system — do not import from shared3d here.

export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;
export const THUMB_WIDTH = 1280;
export const THUMB_HEIGHT = 720;

export const COLORS = {
  bg: "#0B0D12", //   deepest background (lifted from pure-black for bolder contrast)
  bg2: "#070809", //  vignette / outer
  panel: "#12151D", // hard-bordered panel base (NOT glass)
  panel2: "#161A24",
  line: "#222838", //  panel borders / grid
  text: "#EDF1F8",
  dim: "#8A97B2",
  // electric accents — assign by MEANING, max 3 per scene, never gradient-mush
  cyan: "#22E0FF",
  green: "#2BFF88",
  lime: "#B8FF4A",
  magenta: "#FF2D95",
  violet: "#8B5CF6",
  amber: "#FFB020", // warnings / cost / gate-block callouts
  red: "#FF4D4D", //   failure / "wrong"
} as const;

// Ordered spectrum for the per-slide time bar + multi-node colouring.
export const SPECTRUM = [
  COLORS.cyan,
  COLORS.green,
  COLORS.lime,
  COLORS.amber,
  COLORS.magenta,
  COLORS.violet,
] as const;

// CSS gradient string for the multicolour per-slide time bar.
export const TIMEBAR_GRADIENT = `linear-gradient(90deg, ${COLORS.cyan} 0%, ${COLORS.green} 22%, ${COLORS.lime} 40%, ${COLORS.amber} 62%, ${COLORS.magenta} 82%, ${COLORS.violet} 100%)`;

export const FONTS = {
  display: "'Space Grotesk', Inter, system-ui, sans-serif", // headings, oversized numbers
  body: "Inter, system-ui, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, monospace", // code, metadata, node labels, timecodes
} as const;

// Remotion spring presets (snappy = scene entries; gentle = drifts; bouncy = emphasis).
export const SPRING = {
  snappy: { damping: 200, mass: 0.6, stiffness: 180 },
  bouncy: { damping: 90, mass: 0.7, stiffness: 160 },
  gentle: { damping: 150, mass: 1, stiffness: 120 },
} as const;

// Encoded discipline so components can reference it instead of re-deriving.
export const RULES = {
  maxAccentsPerScene: 3,
  bottomSafeZonePx: 80, // keep titles/captions above this for mobile + YT chrome
  timeBarHeightPx: 6,
  codeFocusOpacity: 1,
  codeDimOpacity: 0.3,
  grainOpacity: 0.06,
  sceneTransitionFrames: 15, // ~12-18f fast slides/scale-fades
} as const;

export type AccentName = "cyan" | "green" | "lime" | "magenta" | "violet" | "amber" | "red";
export const accent = (name: AccentName): string => COLORS[name];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
